export type OpmeSolicitation = {
  description: string
  quantity: string
  low_acceptance?: boolean
  source?: string
}

export type CategorizedOpmes = {
  gabarito: OpmeSolicitation[]
  inclusoesMedico: OpmeSolicitation[]
  negado: OpmeSolicitation[]
}

export const categorizeOpmes = (
  opmes: OpmeSolicitation[]
): CategorizedOpmes => {
  const gabarito: OpmeSolicitation[] = []
  const inclusoesMedico: OpmeSolicitation[] = []
  const negado: OpmeSolicitation[] = []

  for (const opme of opmes) {
    if (opme.low_acceptance === true) {
      negado.push(opme)
    } else {
      const normalizedSource = (opme.source ?? '').toLowerCase()
      if (normalizedSource === 'doctor') {
        inclusoesMedico.push(opme)
      } else {
        gabarito.push(opme)
      }
    }
  }

  return { gabarito, inclusoesMedico, negado }
}
